$('.footer__list').on('click', function(evt) {
	$(this).toggleClass('active');
});
